import Section from "./Section";

export default function Allgemein() {
    return <>
        <Section id={'allgemein'} className={'mx-4'}>
            <h2 className={'text-3xl underline mb-2 font-semibold'}>Allgemeines:</h2>
            <ul className={'ml-6 text-xl list-disc underline leading-10'}>
                {/*<ListLink name={'Für die Liebe'} href={'fuer_die_liebe.pdf'}/>*/}
                <ListLink name={'Liederbuch'} href={'Liederbuch.pdf'}/>
                <ListLink name={'JuLeiCa Handbuch'} href={'Juleica_Handbuch.pdf'}/>
                <ListLink name={'Spielesammlungen'} href={'Spielesammlungen.pdf'}/>
            </ul>
        </Section>
    </>
}

export function ListLink({name, href}: {name: string, href: string}) {
    return <>
        <li><a href={'https://handouts.buntergrundkurs.de/2026/' + href} target={'_blank'} >{name}</a></li>
    </>
}